import { render, staticRenderFns } from "./Header.Notify.vue?vue&type=template&id=c9fce7c6&"
import script from "./Header.Notify.vue?vue&type=script&lang=ts&"
export * from "./Header.Notify.vue?vue&type=script&lang=ts&"
import style0 from "./Header.Notify.vue?vue&type=style&index=0&id=c9fce7c6&prod&lang=less&scope=scope&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports